import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from './queryClient';
import AuthorizationProvider from './hooks/Authorize';
import ThemeContextProvider from './style/theme';
import "@fontsource/dm-sans"; 
import "@fontsource/dm-sans/400.css"; 
import "@fontsource/dm-sans/400-italic.css"; 
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <ThemeContextProvider>
        <AuthorizationProvider>
          <App />
        </AuthorizationProvider>
      </ThemeContextProvider>
    </QueryClientProvider>
  </BrowserRouter>
);
